import { render, staticRenderFns } from "./CASEItemAssociations.vue?vue&type=template&id=934689d8"
import script from "./CASEItemAssociations.vue?vue&type=script&lang=js"
export * from "./CASEItemAssociations.vue?vue&type=script&lang=js"
import style0 from "./CASEItemAssociations.vue?vue&type=style&index=0&id=934689d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports